<template>
  <div class="home">
    <section
      data-jarallax
      data-speed=".8"
      class="overlay overlay-black overlay-40 jarallax mb-10 pt-10 pt-md-14 pb-12 pb-md-15"
      style="overflow: hidden"
    >
      <img
        :src="require('../assets/img/' + $store.state.country + '_flag.png')"
        class="international-flag"
      />
      <img
        :src="require('../assets/img/israel_flag.png')"
        class="israel-flag"
      />
      <img :src="bg" class="jarallax-img" />
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-12 col-md-9 text-center">
            <h1 class="display-1 font-weight-bold text-white mb-6 mt-n3">
              There are so many ways to help!
            </h1>

            <button
              class="btn btn-primary btn-lg shadow-dark btn-donate"
              @click.stop="toggleDonate"
              :style="{
                backgroundImage:
                  'url(' +
                  require('@/assets/img/btn_' +
                    $store.state.country +
                    '_flag.jpg') +
                  ')',
              }"
            >
              <span>DONATE NOW</span>
            </button>
          </div>
        </div>
      </div>
      <div class="position-absolute right-0 bottom-0 left-0">
        <div
          class="position-relative shape shape-bottom shape-fluid-x svg-shim text-white"
        >
          <svg
            viewBox="0 0 2880 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0 48h2880V0h-720C1442.5 52 720 0 720 0H0v48z"
              fill="#f1effb"
            />
          </svg>
        </div>
      </div>
    </section>
    <!-- <div class="container">
      <neeman-video />
    </div> -->
    <featured-projects />
    <div class="bg-white mt-10 p-5">
      <div class="container mt-10 mb-10">
        <!-- <div class="row mb-10">
        <div class="col-4">
          <count-up
            :end-val="24000"
            :label="'Donors'"
            :icon="'users'"
            :type="'info'"
          />
        </div>
        <div class="col-4">
          <count-up
            :end-val="10200400"
            :props-prefix="'$'"
            :label="'So far'"
            :icon="'dollar-sign'"
          />
        </div>
        <div class="col-4">
          <count-up
            :end-val="170"
            :label="'Organizations'"
            :icon="'ambulance'"
            :type="'danger'"
          />
        </div>
      </div> -->
        <who-we-are />
      </div>
    </div>
    <div class="mt-10 p-md-5">
      <div class="container">
        <div class="card-body">
          <h3 class="text-center mb-5">Contact Us</h3>
          <contact-form />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { EventBus } from "../event-bus.js";
import ContactForm from "../components/ContactForm";
import WhoWeAre from "../components/WhoWeAre";
import NeemanVideo from "../components/NeemanVideo";
import FeaturedProjects from "../components/FeaturedProjects";
import CountUp from "../components/CountUp";
export default {
  name: "Home",
  components: {
    ContactForm,
    WhoWeAre,
    NeemanVideo,
    FeaturedProjects,
    CountUp,
  },
  data() {
    return {};
  },
  mounted() {},
  computed: {
    bg() {
      return require("../assets/img/" +
        this.$store.state.country +
        "_home_bg.jpg");
    },
  },
  methods: {
    toggleDonate() {
      this.$store.state.showDonate = !this.$store.state.showDonate;
    },
  },
};
</script>
<style>
.jarallax {
  position: relative;
  z-index: 0;
}

.jarallax > .jarallax-img {
  position: absolute;
  object-fit: cover;
  font-family: "object-fit: cover;";
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
}
.jarallax-img {
  background-position: bottom;
}
.israel-flag,
.international-flag {
  position: absolute;
  height: 350px;
  bottom: -30px;
  left: 150px;
}

.international-flag {
  left: 0;
  bottom: 0;
}
@media screen and (max-width: 768px) {
  .israel-flag {
    left: 100px;
  }
  .israel-flag,
  .international-flag {
    height: 200px;
  }
}
</style>